<template>
  <q-page class="flex flex-center bg-gradient-to-br from-primary-1 to-primary-3">
    <q-card class="q-pa-md shadow-10" style="width: 100%; max-width: 450px; border-radius: 16px;">
      
      <!-- Header -->
      <q-card-section class="text-center">
        <q-avatar size="80px" text-color="white" class="q-mb-md">
          
            <img src="../assets/icon2.png" alt="">
         
        </q-avatar>
        <div class="text-h4 text-weight-bold text-grey-9">Criar Conta</div>
        <div class="text-subtitle2 text-grey-6 q-mt-xs">
          Preencha os dados para se registrar
        </div>
      </q-card-section>

      <!-- Mensagem de Sucesso -->
      <q-banner v-if="success" class="bg-positive text-white q-mb-md" rounded>
        <template v-slot:avatar>
          <q-icon name="check_circle" color="white" />
        </template>
        <div class="text-weight-medium">Conta criada com sucesso!</div>
        <div class="text-caption">Foi enviado um email para {{ emailActivate }}, para concluir o registo.</div>
      </q-banner>

      <!-- Mensagem de Erro -->
      <q-banner v-if="submitError" class="bg-negative text-white q-mb-md" rounded>
        <template v-slot:avatar>
          <q-icon name="error" color="white" />
        </template>
        {{ submitError }}
      </q-banner>

      <q-card-section>
        <q-form @submit="onSubmit" @reset="onReset" class="q-gutter-md">
          
          <!-- Nome -->
          <q-input
            v-model="formData.name"
            label="Nome Completo *"
            placeholder="Digite seu nome completo"
            outlined
            dense
            lazy-rules
            :rules="nameRules"
          >
            <template v-slot:prepend>
              <q-icon name="person" />
            </template>
          </q-input>

          <!-- Email -->
          <q-input
            v-model="formData.email"
            type="email"
            label="Email *"
            placeholder="seu@email.com"
            outlined
            dense
            lazy-rules
            :rules="emailRules"
          >
            <template v-slot:prepend>
              <q-icon name="email" />
            </template>
          </q-input>

          <!-- Senha -->
          <q-input
            v-model="formData.password"
            :type="showPassword ? 'text' : 'password'"
            label="Senha *"
            placeholder="Mínimo 6 caracteres"
            outlined
            dense
            lazy-rules
            :rules="passwordRules"
          >
            <template v-slot:prepend>
              <q-icon name="lock" />
            </template>
            <template v-slot:append>
              <q-icon
                :name="showPassword ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="showPassword = !showPassword"
              />
            </template>
          </q-input>

          <!-- Confirmação de Senha -->
          <q-input
            v-model="formData.password_confirmation"
            :type="showPasswordConfirm ? 'text' : 'password'"
            label="Confirmar Senha *"
            placeholder="Repita a senha"
            outlined
            dense
            lazy-rules
            :rules="passwordConfirmRules"
          >
            <template v-slot:prepend>
              <q-icon name="lock" />
            </template>
            <template v-slot:append>
              <q-icon
                :name="showPasswordConfirm ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="showPasswordConfirm = !showPasswordConfirm"
              />
            </template>
          </q-input>

          <!-- Botões -->
          <div class="q-mt-lg">
            <q-btn
              type="submit"
              label="Criar Conta"
              color="primary"
              class="full-width"
              size="lg"
              :loading="loading"
              :disable="loading"
              unelevated
              no-caps
            >
              <template v-slot:loading>
                <q-spinner-hourglass class="on-left" />
                Registrando...
              </template>
            </q-btn>
          </div>

        </q-form>
      </q-card-section>

      <!-- Link para Login -->
      <q-card-section class="text-center q-pt-none">
        <div class="text-body2 text-grey-6">
          Já tem uma conta?
          <a href="/" class="text-primary text-weight-medium" style="text-decoration: none;">
            Fazer login
          </a>
        </div>
      </q-card-section>

    </q-card>
  </q-page>
</template>

<script>
import { ref } from 'vue';
import store from '@/vuex/store';

export default {
  name: 'UserRegistration',

  setup() {

    const formData = ref({
      name: '',
      email: '',
      password: '',
      password_confirmation: ''
    });

    const showPassword = ref(false);
    const showPasswordConfirm = ref(false);
    const loading = ref(false);
    const success = ref(false);
    const submitError = ref('');
    const emailActivate = ref('');

    // Regras de validação
    const nameRules = [
      val => (val && val.length > 0) || 'Nome é obrigatório',
      val => (val && val.length >= 3) || 'Nome deve ter pelo menos 3 caracteres'
    ];

    const emailRules = [
      val => (val && val.length > 0) || 'Email é obrigatório',
      val => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(val) || 'Email inválido';
      }
    ];

    const passwordRules = [
      val => (val && val.length > 0) || 'Senha é obrigatória',
      val => (val && val.length >= 6) || 'Senha deve ter pelo menos 6 caracteres'
    ];

    const passwordConfirmRules = [
      val => (val && val.length > 0) || 'Confirmação de senha é obrigatória',
      val => val === formData.value.password || 'As senhas não correspondem'
    ];

    const onSubmit = async () => {
      loading.value = true;
      success.value = false;
      submitError.value = '';

      try {

        await store.dispatch('auth/autoRegister', {
          name: formData.value.name,
          email: formData.value.email,
          password: formData.value.password,
          password_confirmation: formData.value.password_confirmation
        });

        // Sucesso
        emailActivate.value = formData.value.email;
        success.value = true;
        
        
        // Limpa o formulário
        formData.value = {
          name: '',
          email: '',
          password: '',
          password_confirmation: ''
        };

      } catch (error) {

        console.log(error)

        submitError.value = Object.values(error.response.data.errors)[0][0] || 'Erro ao registrar. Tente novamente.';
        
        
      } finally {
        loading.value = false;
      }
    };

    const onReset = () => {
      formData.value = {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      };
      success.value = false;
      submitError.value = '';
    };

    return {
      formData,
      showPassword,
      showPasswordConfirm,
      emailActivate,
      loading,
      success,
      submitError,
      nameRules,
      emailRules,
      passwordRules,
      passwordConfirmRules,
      onSubmit,
      onReset
    };
  }
};
</script>

<style scoped>
.q-page {
  min-height: 100vh;
}
</style>